import 'trix'
import '../initializers/debounced'
import '../initializers/stimulus'
import '../initializers/stimulus_reflex'